import { AIR_EXPRESS_STATUS, ROUTE_TYPE } from '../../services/flitEnum';

export function getAirExpressStatusCssClasses(status) {
  var type;
  switch (status) {
    case AIR_EXPRESS_STATUS.DRAFT:
      type = "dark";
      break;
    case AIR_EXPRESS_STATUS.SUBMITTED:
      type = "primary";
      break;
    case AIR_EXPRESS_STATUS.CONFIRMED:
      type = "success";
      break;
    case AIR_EXPRESS_STATUS.DOCUMENT_PREPARATION:
      type = "warning";
      break;
    case AIR_EXPRESS_STATUS.BOOKED:
      type = "info";
      break;
    case AIR_EXPRESS_STATUS.PICKED_UP:
      type = "info";
      break;
    case AIR_EXPRESS_STATUS.IN_TRANSIT:
      type = "primary";
      break;
    case AIR_EXPRESS_STATUS.ARRIVED:
      type = "warning";
      break;
    case AIR_EXPRESS_STATUS.CUSTOMS_CLEARED:
      type = "warning";
      break;
    case AIR_EXPRESS_STATUS.DELIVERED:
      type = "danger";
      break;
    case AIR_EXPRESS_STATUS.CANCELLED:
      type = "";
      break;
    case AIR_EXPRESS_STATUS.DELETED:
      type = "";
      break;
    default:
      type = "";
  }

  return `label label-lg label-light-${type} label-inline`;
}

// one order = one AWB : single air route between origin and destination
export function translateAirExpressToRoute(airExpress, quoteRequest) {
  const originLocation = airExpress?.originLocation ?? quoteRequest?.originLocation;
  const destinationLocation = airExpress?.destinationLocation ?? quoteRequest?.destinationLocation;
  if (!originLocation || !destinationLocation) return [];
  return [{
    id: 1, //psudo id
    estimatedDepartureOn: airExpress.estimatedDepartureOn ?? "",
    estimatedArrivalOn: airExpress.estimatedArrivalOn ?? "",
    type: ROUTE_TYPE.AIR,
    originLocation: originLocation,
    destinationLocation: destinationLocation,
  }];
}

export function isValidDate(dateString) {
  if (!dateString) return false;
  const date = new Date(dateString);
  return date instanceof Date && !isNaN(date.getTime());
}
